import React from 'react';

function Pembayaran() {
  return (
    <>
    <section className="relative py-16 bg-center" style={{
      backgroundImage: "url('https://excellencecarrentals.com/wp-content/uploads/2023/05/pexels-lukas-zvikas-1075947.jpg')",
      backgroundSize: 'cover',
      height:'400px'
    }}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative flex items-center justify-center h-full px-4 text-center text-white">
        <div>
          <h1 className="text-3xl font-bold mb-4">Pembayaran</h1>
          <p className="text-lg">
            We are a premier car rental company that offers exceptional service and reliable vehicles to our customers. Our commitment to providing a hassle-free rental experience is at the core of everything we do, and we take pride in ensuring that every customer is satisfied with their rental.
          </p>
        </div>
      </div>
    </section>   
    </>
  );
}

export default Pembayaran;